import React from 'react'

import Patientlogin from '../../Components/Patient/Patientlogin/Patientlogin'
import Nav from '../../Components/Patient/Nav/Nav'

function LoginForm() {
  return (
    <div>
      <Nav />
      <Patientlogin/>
    </div>
  )
}

export default LoginForm